import React from "react";
import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#29C2BA",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fd4060",
      contrastText: "#fff",
    },
    background: {
      default: "#02162b",
      paper: "#02162b",
    },
  },
  typography: {
    fontFamily: "Arial, Helvetica, sans-serif",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*": {
          boxSizing: "border-box",
        },
        html: {
          backgroundColor: "#02162b",
          margin: "0",
          padding: "0",
          width: "100%",
          height: "100%",
        } as React.CSSProperties,
        body: {
          backgroundColor: "#02162b",
          margin: "0",
          padding: "0",
          overflowX: "hidden",
          width: "100%",
          minHeight: "100vh",
        } as React.CSSProperties,
        "#root": {
          backgroundColor: "#02162b",
          margin: "0",
          padding: "0",
          minHeight: "100vh",
          width: "100%",
        } as React.CSSProperties,
        ".MuiBox-root": {
          backgroundColor: "transparent",
        } as React.CSSProperties,
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: "#02162b",
        background: "#02162b",
      },
    },
    MuiButton: {
      contained: {
        borderRadius: 50,
        padding: "6px 24px",
        minWidth: 200,
      },
    },
  },
});

const themeWithResponsiveFonts = responsiveFontSizes(theme);

export default themeWithResponsiveFonts;

